
export enum Status {
    NONE = 'none',
    LOADING = 'loading',
    READY = 'ready',
    ERROR = 'error',
    SUCCESS = 'success',
}